import { Link } from 'react-router-dom';

import useStyles from './checkout-footer.styles';

const CheckoutFooter = () => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <div className={classes.helpAndPolicies}>
        <Link to="/" className={classes.help}>
          Need Help?
        </Link>
        <div className={classes.horizontalLine} />
        <div className={classes.policies}>
          <Link to="/">Shipping & Return</Link>
          <Link to="/">Privacy policy</Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutFooter;
